export const getRootTicketLink = () => {
  /* This is duplicated in the routes in app.js */
  return '/browse/jobs';
};


export const getTicketLink = (ticketId, jobId, showHeader = true) => {
  const rootLink = getRootTicketLink();
  return `${rootLink}/${jobId}?ticketId=${ticketId}&showHeader=${showHeader}`;
};
